import React from 'react';
import { AppBar, Toolbar, Button, IconButton, Box, Menu, MenuItem, Typography, Container, ListItemIcon, ListItemText, Drawer, List, ListItem, ListItemButton, Collapse } from '@mui/material';
import { Link } from 'react-router-dom';
import CampaignIcon from '@mui/icons-material/Campaign';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuIcon from '@mui/icons-material/Menu';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import SecurityIcon from '@mui/icons-material/Security';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import PublicIcon from '@mui/icons-material/Public';
import DnsIcon from '@mui/icons-material/Dns';
import BuildIcon from '@mui/icons-material/Build';
import AppsIcon from '@mui/icons-material/Apps';

const StyledAppBar = AppBar;
const StyledToolbar = Toolbar;
const Logo = (props: any) => <img style={{ height: 30, width: 'auto' }} {...props} />;
const NavLink = Button;

const Navbar: React.FC = () => {
  const [servicesAnchorEl, setServicesAnchorEl] = React.useState<null | HTMLElement>(null);
  const [productsAnchorEl, setProductsAnchorEl] = React.useState<null | HTMLElement>(null);
  const [toolsAnchorEl, setToolsAnchorEl] = React.useState<null | HTMLElement>(null);
  const [consultingAnchorEl, setConsultingAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileDrawerOpen, setMobileDrawerOpen] = React.useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = React.useState(false);
  const [mobileConsultingOpen, setMobileConsultingOpen] = React.useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = React.useState(false);
  const [mobileToolsOpen, setMobileToolsOpen] = React.useState(false);

  const handleServicesClick = (event: React.MouseEvent<HTMLElement>) => {
    setServicesAnchorEl(event.currentTarget);
  };
  const handleProductsClick = (event: React.MouseEvent<HTMLElement>) => {
    setProductsAnchorEl(event.currentTarget);
  };
  const handleToolsClick = (event: React.MouseEvent<HTMLElement>) => {
    setToolsAnchorEl(event.currentTarget);
  };
  const handleConsultingClick = (event: React.MouseEvent<HTMLElement>) => {
    setConsultingAnchorEl(event.currentTarget);
  };
  const handleMobileMenuClick = () => {
    setMobileDrawerOpen(true);
  };
  const handleMobileDrawerClose = () => {
    setMobileDrawerOpen(false);
    setMobileServicesOpen(false);
    setMobileConsultingOpen(false);
    setMobileProductsOpen(false);
    setMobileToolsOpen(false);
  };
  const handleClose = () => {
    setServicesAnchorEl(null);
    setProductsAnchorEl(null);
    setToolsAnchorEl(null);
    setConsultingAnchorEl(null);
  };

  return (
    <StyledAppBar position="fixed" sx={{ backgroundColor: 'rgba(255,255,255,0.95)', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', backdropFilter: 'blur(10px)' }}>
      <Container>
        <StyledToolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Link to="/">
            <Logo src="/images/impactquill_svg.svg" alt="ImpactQuill Logo" />
          </Link>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', flexGrow: 1, gap: 0.5 }}>
            <NavLink onClick={handleServicesClick} sx={{ color: '#0B60B1', fontWeight: 500, fontSize: '1rem', letterSpacing: '0.5px', mx: 0.1, px: 0.8, py: 0.4, minHeight: 32, display: 'flex', alignItems: 'center', textTransform: 'none' }}>
              Services <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
            </NavLink>
            <NavLink onClick={handleConsultingClick} sx={{ color: '#0B60B1', fontWeight: 500, fontSize: '1rem', letterSpacing: '0.5px', mx: 0.1, px: 0.8, py: 0.4, minHeight: 32, display: 'flex', alignItems: 'center', textTransform: 'none' }}>
              Consulting <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
            </NavLink>
            <NavLink onClick={handleProductsClick} sx={{ color: '#0B60B1', fontWeight: 500, fontSize: '1rem', letterSpacing: '0.5px', mx: 0.1, px: 0.8, py: 0.4, minHeight: 32, display: 'flex', alignItems: 'center', textTransform: 'none' }}>
              Products <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
            </NavLink>
            <NavLink onClick={handleToolsClick} sx={{ color: '#0B60B1', fontWeight: 500, fontSize: '1rem', letterSpacing: '0.5px', mx: 0.1, px: 0.8, py: 0.4, minHeight: 32, display: 'flex', alignItems: 'center', textTransform: 'none' }}>
              Tools <KeyboardArrowDownIcon fontSize="small" sx={{ ml: 0.5 }} />
            </NavLink>
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Button variant="contained" color="primary" component={Link} to="/contact" startIcon={<ContactMailIcon />} sx={{ position: 'relative', zIndex: 1300 }}>
              Contact Us
            </Button>
            <Button
              component={Link}
              to="/book-meeting"
              sx={{
                ml: 1.5,
                fontWeight: 500,
                color: '#0B60B1',
                fontSize: '0.95rem',
                textTransform: 'none',
                border: '1.5px solid #0B60B1',
                background: 'transparent',
                boxShadow: 'none',
                minHeight: 36,
                px: 2.2,
                '&:hover': {
                  background: 'rgba(11,96,177,0.07)',
                  borderColor: '#094a8f',
                },
              }}
              variant="outlined"
            >
              Schedule a meeting
            </Button>
          </Box>
          <Box sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' }, alignItems: 'center', zIndex: 2000 }}>
            <IconButton
              edge="end"
              color="primary"
              aria-label="menu"
              onClick={handleMobileMenuClick}
              sx={{ display: 'flex', zIndex: 2000 }}
            >
              <MenuIcon sx={{ fontSize: 32 }} />
            </IconButton>
          </Box>
        </StyledToolbar>
      </Container>
      {/* Services Mega Menu */}
      <Menu
        anchorEl={servicesAnchorEl}
        open={Boolean(servicesAnchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          sx: {
            mt: 1,
            boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
            borderRadius: 2,
            p: 0,
          },
        }}
      >
        <Box sx={{ p: 4, maxWidth: '1000px', minWidth: '700px', mx: 'auto' }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {/* Email Services */}
            <Box sx={{ flex: '1 1 200px', minWidth: 0 }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" color="primary" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <EmailIcon sx={{ mr: 1 }} /> Email Services
                </Typography>
                <Box sx={{ pl: 2 }}>
                  <MenuItem 
                    component={Link} 
                    to="/services/email-deliverability" 
                    onClick={handleClose}
                    sx={{ 
                      p: 2, 
                      mb: 1, 
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(11,96,177,0.05)',
                        transform: 'translateX(8px)',
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Email Deliverability</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Maximize inbox placement and avoid spam folders
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem 
                    component={Link} 
                    to="/services/email-audit" 
                    onClick={handleClose}
                    sx={{ 
                      p: 2, 
                      mb: 1, 
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(11,96,177,0.05)',
                        transform: 'translateX(8px)',
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Email Auditing</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Comprehensive analysis of your email setup
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem 
                    component={Link} 
                    to="/services/email-marketing" 
                    onClick={handleClose}
                    sx={{ 
                      p: 2, 
                      mb: 1, 
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(11,96,177,0.05)',
                        transform: 'translateX(8px)',
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Email Marketing</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Drive engagement with data-driven campaigns
                      </Typography>
                    </Box>
                  </MenuItem>
                </Box>
              </Box>
            </Box>

            {/* SEO Services */}
            <Box sx={{ flex: '1 1 200px', minWidth: 0 }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" color="primary" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <TrendingUpIcon sx={{ mr: 1 }} /> SEO Services
                </Typography>
                <Box sx={{ pl: 2 }}>
                  <MenuItem 
                    component={Link} 
                    to="/services/seo" 
                    onClick={handleClose}
                    sx={{ 
                      p: 2, 
                      mb: 1, 
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(11,96,177,0.05)',
                        transform: 'translateX(8px)',
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Search Engine Optimization</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Improve your site's visibility and rankings
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem 
                    component={Link} 
                    to="/services/seo-audit" 
                    onClick={handleClose}
                    sx={{ 
                      p: 2, 
                      mb: 1, 
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(11,96,177,0.05)',
                        transform: 'translateX(8px)',
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>SEO Audit</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Comprehensive analysis of your site's SEO
                      </Typography>
                    </Box>
                  </MenuItem>
                </Box>
              </Box>
            </Box>

            {/* LinkedIn Services */}
            <Box sx={{ flex: '1 1 200px', minWidth: 0 }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="h6" color="primary" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <LinkedInIcon sx={{ mr: 1 }} /> LinkedIn Services
                </Typography>
                <Box sx={{ pl: 2 }}>
                  <MenuItem 
                    component={Link} 
                    to="/services/linkedin-marketing" 
                    onClick={handleClose}
                    sx={{ 
                      p: 2, 
                      mb: 1, 
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(11,96,177,0.05)',
                        transform: 'translateX(8px)',
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>LinkedIn Marketing</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Strategic campaigns for B2B growth
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem 
                    component={Link} 
                    to="/services/linkedin-optimization" 
                    onClick={handleClose}
                    sx={{ 
                      p: 2, 
                      mb: 1, 
                      borderRadius: 1,
                      '&:hover': {
                        bgcolor: 'rgba(11,96,177,0.05)',
                        transform: 'translateX(8px)',
                      },
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Profile Optimization</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Maximize your LinkedIn presence
                      </Typography>
                    </Box>
                  </MenuItem>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Menu>
      {/* Consulting Mega Menu */}
      <Menu
        anchorEl={consultingAnchorEl}
        open={Boolean(consultingAnchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          sx: {
            mt: 1,
            boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
            borderRadius: 2,
            p: 0,
            width: '100%',
            maxWidth: '1200px',
            left: '50%',
            transform: 'translateX(-50%)',
            margin: 0,
            position: 'absolute',
            zIndex: 1200
          },
        }}
      >
        <Box sx={{ p: 4, width: '100%', display: 'flex', justifyContent: 'center', margin: 0 }}>
          <Box sx={{ width: '100%', maxWidth: '1200px' }}>
            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: 1.2 }}>
              {/* Marketing Suite */}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <CampaignIcon color="primary" sx={{ mr: 1, fontSize: 28 }} />
                  <Typography variant="h6" color="primary" fontWeight={700}>Marketing Suite</Typography>
                </Box>
                <Box sx={{ pl: 2 }}>
                  <MenuItem component={Link} to="/consulting/instantly" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Instantly</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Cold email automation and campaign consulting.
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/smartlead" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Smartlead</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Smartlead platform setup and optimization.
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/klaviyo" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Klaviyo</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Klaviyo email marketing and automation consulting.
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/gohighlevel" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>GoHighLevel</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        GoHighLevel CRM and marketing consulting.
                      </Typography>
                    </Box>
                  </MenuItem>
                </Box>
              </Box>

              {/* Email Automation Suite */}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <EmailIcon color="primary" sx={{ mr: 1, fontSize: 28 }} />
                  <Typography variant="h6" color="primary" fontWeight={700}>Email Automation Suite</Typography>
                </Box>
                <Box sx={{ pl: 2 }}>
                  <MenuItem component={Link} to="/consulting/mailwizz" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>MailWizz</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Self-hosted email marketing for large-scale campaigns
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/mautic" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Mautic</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Open-source marketing automation platform
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/listmonk" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Listmonk</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        High-performance newsletter and mailing list manager
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/phplist" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>phpList</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Reliable open-source email campaign manager
                      </Typography>
                    </Box>
                  </MenuItem>
                </Box>
              </Box>

              {/* Email Delivery */}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <MarkEmailReadIcon color="primary" sx={{ mr: 1, fontSize: 28 }} />
                  <Typography variant="h6" color="primary" fontWeight={700}>Email Delivery</Typography>
                </Box>
                <Box sx={{ pl: 2 }}>
                  <MenuItem component={Link} to="/consulting/mailcow" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Mailcow</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Advanced mail server suite with webmail and admin interface
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/powermta" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>PowerMTA</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        PowerMTA server setup and optimization.
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/postal" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Postal</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Postal MTA configuration and support.
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem component={Link} to="/consulting/postfix" onClick={handleClose} sx={{ p: 1.2, mb: 0.5, borderRadius: 1, alignItems: 'flex-start', '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateX(8px)' }, transition: 'all 0.2s ease' }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight={600}>Postfix</Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 200 }}>
                        Postfix mail server consulting and support.
                      </Typography>
                    </Box>
                  </MenuItem>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Menu>
      {/* Products Dropdown */}
      <Menu
        anchorEl={productsAnchorEl}
        open={Boolean(productsAnchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          sx: {
            minWidth: 320,
            maxWidth: 400,
            mt: 1,
            boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
            borderRadius: 2,
            p: 0,
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ mb: 2, p: 2, borderRadius: 2, '&:hover': { bgcolor: 'rgba(11,96,177,0.05)' }, transition: 'all 0.2s' }} component={Link} to="/products/iqdmarc" onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <SecurityIcon color="primary" sx={{ mr: 1 }} />
              <Typography variant="subtitle1" fontWeight={700}>IQDMARC</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 300 }}>
              Managed DMARC, SPF, and DKIM security suite for your domain.
            </Typography>
          </Box>
          <Box sx={{ mb: 2, p: 2, borderRadius: 2, '&:hover': { bgcolor: 'rgba(11,96,177,0.05)' }, transition: 'all 0.2s' }} component={Link} to="/products/spam0" onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <VerifiedUserIcon color="primary" sx={{ mr: 1 }} />
              <Typography variant="subtitle1" fontWeight={700}>SPAM0</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 300 }}>
              Protect your domain and IP from low reputation and spam blacklists.
            </Typography>
          </Box>
        </Box>
      </Menu>
      {/* Tools Mega Menu (Desktop) */}
      <Menu
        anchorEl={toolsAnchorEl}
        open={Boolean(toolsAnchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          sx: {
            minWidth: 600,
            maxWidth: 900,
            mt: 1,
            boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
            borderRadius: 2,
            p: 0,
          },
        }}
      >
        <Box sx={{ p: 3, maxWidth: '800px', mx: 'auto' }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center' }}>
            {/* DNS Super Tool */}
            <Box sx={{ flex: '1 1 220px', minWidth: 220, maxWidth: 260, p: 2, borderRadius: 2, '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateY(-4px)' }, transition: 'all 0.2s' }} component={Link} to="/tools/dns-super-tool" onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <PublicIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="subtitle1" fontWeight={700}>DNS Super Tool</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 220 }}>
                All-in-one DNS lookup and diagnostics for your domain.
              </Typography>
            </Box>
            {/* SPF Analyzer */}
            <Box sx={{ flex: '1 1 220px', minWidth: 220, maxWidth: 260, p: 2, borderRadius: 2, '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateY(-4px)' }, transition: 'all 0.2s' }} component={Link} to="/tools/spf-analyzer" onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <DnsIcon color="success" sx={{ mr: 1 }} />
                <Typography variant="subtitle1" fontWeight={700}>SPF Analyzer</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 220 }}>
                Analyze and validate your SPF records for best practices.
              </Typography>
            </Box>
            {/* DMARC Analyzer */}
            <Box sx={{ flex: '1 1 220px', minWidth: 220, maxWidth: 260, p: 2, borderRadius: 2, '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateY(-4px)' }, transition: 'all 0.2s' }} component={Link} to="/tools/dmarc-analyzer" onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <SecurityIcon color="info" sx={{ mr: 1 }} />
                <Typography variant="subtitle1" fontWeight={700}>DMARC Analyzer</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 220 }}>
                Check your DMARC policy and get actionable recommendations.
              </Typography>
            </Box>
            {/* DKIM Analyzer */}
            <Box sx={{ flex: '1 1 220px', minWidth: 220, maxWidth: 260, p: 2, borderRadius: 2, '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateY(-4px)' }, transition: 'all 0.2s' }} component={Link} to="/tools/dkim-analyzer" onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <SecurityIcon color="warning" sx={{ mr: 1 }} />
                <Typography variant="subtitle1" fontWeight={700}>DKIM Analyzer</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 220 }}>
                Verify your DKIM configuration and troubleshoot issues.
              </Typography>
            </Box>
            {/* MX Check */}
            <Box sx={{ flex: '1 1 220px', minWidth: 220, maxWidth: 260, p: 2, borderRadius: 2, '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateY(-4px)' }, transition: 'all 0.2s' }} component={Link} to="/tools/mx-analyzer" onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <EmailIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="subtitle1" fontWeight={700}>MX Analyzer</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 220 }}>
                Instantly check your domain's MX records for mail delivery.
              </Typography>
            </Box>
            {/* Email Test */}
            <Box sx={{ flex: '1 1 220px', minWidth: 220, maxWidth: 260, p: 2, borderRadius: 2, '&:hover': { bgcolor: 'rgba(11,96,177,0.05)', transform: 'translateY(-4px)' }, transition: 'all 0.2s' }} component={Link} to="/tools/email-test" onClick={handleClose} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <EmailIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="subtitle1" fontWeight={700}>Email Test</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: 220 }}>
                Test your email configuration and deliverability.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Menu>
      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileDrawerOpen}
        onClose={handleMobileDrawerClose}
        PaperProps={{
          sx: {
            width: '100%',
            maxWidth: 320,
            bgcolor: 'background.paper',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <List>
            {/* Services */}
            <ListItem disablePadding>
              <ListItemButton onClick={() => setMobileServicesOpen(!mobileServicesOpen)}>
                <ListItemIcon><EmailIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Services" />
                <KeyboardArrowDownIcon sx={{ transform: mobileServicesOpen ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
              </ListItemButton>
            </ListItem>
            <Collapse in={mobileServicesOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton component={Link} to="/services/email-deliverability" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>Email Deliverability</ListItemButton>
                <ListItemButton component={Link} to="/services/email-audit" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>Email Audit</ListItemButton>
                <ListItemButton component={Link} to="/services/email-marketing" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>Email Marketing</ListItemButton>
              </List>
            </Collapse>

            {/* Consulting */}
            <ListItem disablePadding>
              <ListItemButton onClick={() => setMobileConsultingOpen(!mobileConsultingOpen)}>
                <ListItemIcon><BuildIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Consulting" />
                <KeyboardArrowDownIcon sx={{ transform: mobileConsultingOpen ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
              </ListItemButton>
            </ListItem>
            <Collapse in={mobileConsultingOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton component={Link} to="/consulting/instantly" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>Instantly</ListItemButton>
                <ListItemButton component={Link} to="/consulting/smartlead" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>Smartlead</ListItemButton>
                <ListItemButton component={Link} to="/consulting/klaviyo" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>Klaviyo</ListItemButton>
                <ListItemButton component={Link} to="/consulting/gohighlevel" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>GoHighLevel</ListItemButton>
              </List>
            </Collapse>

            {/* Products */}
            <ListItem disablePadding>
              <ListItemButton onClick={() => setMobileProductsOpen(!mobileProductsOpen)}>
                <ListItemIcon><SecurityIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Products" />
                <KeyboardArrowDownIcon sx={{ transform: mobileProductsOpen ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
              </ListItemButton>
            </ListItem>
            <Collapse in={mobileProductsOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton component={Link} to="/products/iqdmarc" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>IQDMarc</ListItemButton>
                <ListItemButton component={Link} to="/products/spam0" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>SPAM0</ListItemButton>
              </List>
            </Collapse>

            {/* Tools */}
            <ListItem disablePadding>
              <ListItemButton onClick={() => setMobileToolsOpen(!mobileToolsOpen)}>
                <ListItemIcon><AppsIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Tools" />
                <KeyboardArrowDownIcon sx={{ transform: mobileToolsOpen ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
              </ListItemButton>
            </ListItem>
            <Collapse in={mobileToolsOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton component={Link} to="/tools/dns-super-tool" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>DNS Super Tool</ListItemButton>
                <ListItemButton component={Link} to="/tools/spf-analyzer" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>SPF Analyzer</ListItemButton>
                <ListItemButton component={Link} to="/tools/dmarc-analyzer" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>DMARC Analyzer</ListItemButton>
                <ListItemButton component={Link} to="/tools/dkim-analyzer" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>DKIM Analyzer</ListItemButton>
                <ListItemButton component={Link} to="/tools/mx-analyzer" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>MX Analyzer</ListItemButton>
                <ListItemButton component={Link} to="/tools/email-test" onClick={handleMobileDrawerClose} sx={{ pl: 6 }}>Email Test</ListItemButton>
              </List>
            </Collapse>
          </List>
        </Box>
      </Drawer>
    </StyledAppBar>
  );
};

export default Navbar; 